// src/utils/localStorageCache.js
export const setWithExpiry = (key, value, ttlInHours) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttlInHours * 60 * 60 * 1000 // Convert hours to milliseconds
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // Compare the stored expiry time with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, remove it from localStorage and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};